






import { defineComponent } from '@vue/composition-api';
import { bemx } from '@berlin-front/common/utils';

export default defineComponent({
  name: 'AttributeList',

  setup() {
    const className = bemx('AttributeList');
    return {
      className,
    };
  },
});
